function isString(str) {
    return typeof (str) === 'string';
}
var ArrayPro = (function () {
    function ArrayPro(opt) {
        this.max = opt.max || 0;
        this.order = opt.order || true;
        this.isAsc = opt.isAcs === undefined ? true : opt.isAcs;
        this._keys = [];
        this._data = {};
    }
    ArrayPro.prototype.set = function (k, v, type) {
        var _a = this, _keys = _a._keys, _data = _a._data, order = _a.order, max = _a.max;
        var i = this._keys.indexOf(k);
        if (i > -1) {
            if (order === true) {
                _keys.splice(i, 1);
                _keys.push(k);
            }
        }
        else {
            if (type === "back") {
                _keys.push(k);
            }
            else {
                _keys.unshift(k);
            }
        }
        _data[k] = v;
        if (max > 0 && _keys.length > max) {
            this.remove(_keys[_keys.length - 1]);
        }
    };
    ArrayPro.prototype.get = function (k) {
        return this._data[k];
    };
    ArrayPro.prototype.getBy = function (key, val) {
        var _data = this._data;
        for (var i in _data) {
            if (_data[key] === val) {
                return _data[i];
            }
        }
        return undefined;
    };
    ArrayPro.prototype._sort = function () {
        var _this = this;
        if (isString(this.order)) {
            this._keys = this._keys.sort(function (d1, d2) {
                var diff = _this._data[d1][_this.order] - _this._data[d2][_this.order];
                return _this.isAsc ? diff : -diff;
            });
            return this._keys;
        }
        else {
            return this._keys;
        }
    };
    ArrayPro.prototype.getAll = function () {
        var _this = this;
        return this._sort().map(function (d) {
            return _this._data[d];
        });
    };
    ArrayPro.prototype.remove = function (k) {
        var i = this._keys.indexOf(k);
        if (i > -1) {
            this._keys.splice(i, 1);
            delete this._data[k];
        }
    };
    ArrayPro.prototype.clear = function () {
        this._keys = [];
        this._data = {};
    };
    ArrayPro.prototype.forEach = function (fn) {
        var _this = this;
        this._sort().forEach(function (ret) {
            fn(ret, _this._data[ret]);
        });
    };
    return ArrayPro;
}());
export default ArrayPro;
